module.exports = __webpack_public_path__ + "static/media/butchering.e38aebaa.webp";